import { isFeatureEnabled } from 'owa-feature-flags';
import { getConfig } from 'owa-service/lib/config';

export default function isNestedAppAuthAvailable(): boolean {
    return (
        (isFeatureEnabled('auth-naa-native') || isFeatureEnabled('auth-naa-web')) &&
        !!getConfig().executeNaaRequest
    );
}
